<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "Contrato"
    },
    clientesInativo: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    contratoTipoList: {},
    clienteList: {},
    tabelaCalculoList: {},
    deslocamentoFixo: true
  }),
  created() {
    this.getContratoTipoList();
    this.getClienteList();
    this.getTabelaCalculoList();
  },
  watch: {
    deslocamentoFixo: function() {
      this.item.tipoAdicionalPresencial = this.deslocamentoFixo ? "F" : "D";
      if (this.deslocamentoFixo) {
        this.item.distanciaDeslocamento = 0;
      } else {
        this.item.adicionalPresencial = 0;
      }
    }
  },
  methods: {
    get(id) {
      api.get(`crud/${this.table}/${id}`).then(response => {
        this.item = response.data["data"];
        this.deslocamentoFixo =
          this.item.tipoAdicionalPresencial == "F" ? true : false;
      });
    },
    getContratoTipoList() {
      api
        .get(`crud/ContratoTipo`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.contratoTipoList = response.data["data"]));
    },
    getClienteList() {
      api
        .get(`crud/Expediente/listaClientes`, {
          params: {
            ativo: this.clientesInativo
          }
        })
        .then(response => (this.clienteList = response.data["data"]));
    },
    getTabelaCalculoList() {
      api
        .get(`crud/TabelaCalculo`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.tabelaCalculoList = response.data["data"]));
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group id="input-group-1" label="Descrição" label-for="descricao">
        <b-form-input
          id="descricao"
          v-model="item.descricao"
          :disabled="!this.editForm"
          type="text"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-1" label="Cliente" label-for="clienteId">
        <b-form-select
          id="clienteId"
          v-model="item.clienteId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in clienteList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.nome }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-2"
        label="Tipo do contrato"
        label-for="contratoTipoId"
      >
        <b-form-select
          id="contratoTipoId"
          v-model="item.contratoTipoId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in contratoTipoList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.descricao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-2"
        label="Tabela de cálculo"
        label-for="tabelaCalculoId"
      >
        <b-form-select
          id="tabelaCalculoId"
          v-model="item.tabelaCalculoId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in tabelaCalculoList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.descricao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Data de início"
          label-for="data"
          class="col-md-6"
        >
          <b-form-datepicker
            id="dataInicio"
            v-model="item.dataInicio"
            :disabled="!this.editForm"
            required
            placeholder="Selecione uma data"
            :hide-header="true"
          ></b-form-datepicker>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Data de término"
          label-for="dataFim"
          class="col-md-6"
        >
          <b-form-datepicker
            id="dataFim"
            v-model="item.dataFim"
            :disabled="!this.editForm"
            required
            placeholder="Selecione uma data"
            :hide-header="true"
          ></b-form-datepicker>
        </b-form-group>
      </div>

      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Carga horária total (horas)"
          label-for="cargaHoraria"
          class="col-md-3"
        >
          <b-form-input
            id="cargaHoraria"
            v-model="item.cargaHoraria"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999.00"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Valor total (R$)"
          label-for="valorCobrado"
          class="col-md-3"
        >
          <b-form-input
            id="valorCobrado"
            v-model="item.valorCobrado"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999999.00"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Excedente remoto (R$)"
          label-for="valorCobrado"
          class="col-md-3"
        >
          <b-form-input
            id="valorCobrado"
            v-model="item.horaAvulsaRemota"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999999.00"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Excedente presencial (R$)"
          label-for="valorCobrado"
          class="col-md-3"
        >
          <b-form-input
            id="valorCobrado"
            v-model="item.horaAvulsaPresencial"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999999.00"
          ></b-form-input>
        </b-form-group>
      </div>

      <div class="row">
        <b-form-group id="input-group-1" class="float-right mt-4 col-md-3">
          <b-form-checkbox
            v-model="deslocamentoFixo"
            :disabled="!this.editForm"
            name="check-button"
            switch
          >
            Deslocamento fixo
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Distância deslocamento (km)"
          label-for="distanciaDeslocamento"
          class="col-md-3"
          v-if="!deslocamentoFixo"
        >
          <b-form-input
            id="distanciaDeslocamento"
            v-model="item.distanciaDeslocamento"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999.00"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Adicional presencial (%)"
          label-for="adicionalPresencial"
          class="col-md-3"
          v-if="deslocamentoFixo"
        >
          <b-form-input
            id="adicionalPresencial"
            v-model="item.adicionalPresencial"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999999.00"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="SNU Excedente(h)"
          label-for="sNUExcedente"
          class="col-md-3"
        >
          <b-form-input
            id="sNUExcedente"
            v-model="item.snuExcedente"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999999.00"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="Carga horária mínima (h)"
          label-for="chMinimoMes"
          class="col-md-3"
        >
          <b-form-input
            id="cHMinimo"
            v-model="item.chMinimoMes"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999999.00"
          ></b-form-input>
        </b-form-group>
      </div>

      <b-form-group
        id="input-group-1"
        label="Observação"
        label-for="observacao"
      >
        <b-form-textarea
          id="observacao"
          v-model="item.observacao"
          placeholder="Observação..."
          type="text"
          :disabled="!this.editForm"
          rows="5"
        />
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>

    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
